module.exports = "//static.hsappstatic.net/LearningCenterUI/static-1.33807/images/pngs/homepage-hero.webp"